import * as React from "react";
import { X } from "lucide-react";
import { Button } from "./Button";

/**
 * The row above a list: filters on the left, search on the right.
 *
 * It exists to hold one rule rather than to save markup. **"Clear" only appears
 * when something is actually filtered**, and `activeCount` is what decides that
 * - so the page has to state which of its filters count as set, and the bar can
 * say how many it is about to drop. A permanently visible reset control on an
 * unfiltered list is a button that does nothing, and one that carries no count
 * asks the user to guess what it will undo.
 *
 * Filters go in as children rather than as a config array. They are already
 * components with their own options and handlers, and a `FilterSpec[]` registry
 * would be a second vocabulary to learn for the same three lines of JSX.
 */
export function FilterBar({
  children,
  search,
  activeCount = 0,
  onClear,
}: {
  /** The filter controls, usually `FilterSelect`s. */
  children?: React.ReactNode;
  /** The `SearchInput`, pushed to the end of the row. */
  search?: React.ReactNode;
  activeCount?: number;
  onClear?: () => void;
}) {
  return (
    <div className="filter-bar">
      {children && <div className="filter-bar__filters">{children}</div>}

      {onClear && activeCount > 0 && (
        <Button variant="ghost" size="sm" icon={<X />} onClick={onClear}>
          Clear {activeCount}
        </Button>
      )}

      {search && <div className="filter-bar__search">{search}</div>}
    </div>
  );
}
